
      import {main} from './build/dev/javascript/bullet_heck_gleam/bullet_heck_gleam.mjs'
      main();
    